import { Skeleton } from '@mui/material'
import { FC } from 'react'

export const BillingSkeleton: FC = () => (
    <>
        <Skeleton
            variant="rectangular"
            width="100%"
            height={20}
            sx={{ borderRadius: '24px', m: '8px 0' }}
        />
        <Skeleton
            variant="rectangular"
            width="100%"
            height={20}
            sx={{ borderRadius: '24px', m: '8px 0' }}
        />
        <Skeleton
            variant="rectangular"
            width="100%"
            height={20}
            sx={{ borderRadius: '24px', m: '8px 0' }}
        />
    </>
)
